import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { Admin, InterviewResult } from '@core/interview-results-types';
import { DateComponent } from '@core/time-ui';
import {
  DividerComponent,
  TruncateComponent,
  BadgeComponent,
  AvatarComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-interview-member',
  templateUrl: 'interview-member.component.html',
  styleUrls: ['./interview-member.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    BadgeComponent,
    TruncateComponent,
    DividerComponent,
    DateComponent,
    TranslatePipe,
  ],
})
export class InterviewMemberComponent {
  private readonly i18n = inject(I18nService);

  @Input() public result: InterviewResult;

  public name: string;
  public initials?: string;
  public photoThumbUrl: string;
  public authorExists: boolean = false;

  public ngOnChanges() {
    this.setData();
  }

  public setPhotoThumbUrl() {
    this.photoThumbUrl = this.result.admin
      ? this.result.admin.photoThumbUrl
      : this.result.guest!.photoThumbUrl;
  }

  public setName() {
    if (this.result.admin) {
      this.name = this.result.admin.firstName
        ? `${this.result.admin.firstName} ${this.result.admin.lastName}`
        : (<Admin>this.result.admin).name;
    } else if (this.result.guest) {
      this.name = this.result.guest.name;
    }
  }

  public setInitials() {
    this.initials = this.result.admin ? this.result.admin.initials : this.result.guest!.initials;
  }

  public setData() {
    this.checkIfAuthorExists();
    if (this.authorExists) {
      this.setInitials();
      this.setName();
      this.setPhotoThumbUrl();
    } else {
      this.setDataForDeletedUser();
    }
  }

  private checkIfAuthorExists() {
    this.authorExists = !!(
      (this.result.admin && !this.result.admin.anonymizedAt) ||
      this.result.guest
    );
  }

  private setDataForDeletedUser() {
    this.name = this.i18n.translate('app.common.deleted_user');
  }
}
